import { createActionTypeModel } from "../../../../store/global/action-model";

export const Users = createActionTypeModel('Users');
export const SelectedUser = createActionTypeModel('SelectedUser');
export const UserDetails = createActionTypeModel('UserDetails');
export const HIDE_USER_MODULE = 'HIDE_USER_MODULE';
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const DELETE_HIDDEN_INVOICE_PROJECT = 'DELETE_HIDDEN_INVOICE_PROJECT';
export const DELETE_HIDDEN_ARTISTS_FEES = 'DELETE_HIDDEN_ARTISTS_FEES';
export const SELECT_USER_AUTO = 'SELECT_USER_AUTO';
